module.exports = require("bcryptjs");